import { render } from "./PhotoUpload.vue?vue&type=template&id=55751122"
import script from "./PhotoUpload.vue?vue&type=script&lang=js"
export * from "./PhotoUpload.vue?vue&type=script&lang=js"

import "./PhotoUpload.vue?vue&type=style&index=0&id=55751122&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__